import {
    FaComments,
    FaEnvelope,
    FaGlobe,
    FaStore,
    FaMobileAlt,
} from "react-icons/fa";
import logo from "../assets/images/logo.png";
import styles from "./ContactUs.module.css";
import baleIcon from "../assets/images/bale.svg";
import bazaarIcon from "../assets/icons/cafebazaar.webp";


const SUPPORT_EMAIL = "support@autoyad.ir";

const WEBSITE_URL = "https://www.autoyad.ir";

const BALE_CHANNEL_URL = "https://ble.ir/autoyad";

const BAZAAR_URL = "https://cafebazaar.ir/app/ir.autoyad.app.twa";

const BALE_SUPPORT_URL = "https://ble.ir/mehdizz1";

const PWA_URL = "https://app.autoyad.ir";

const APP_VERSION = "2.8.5";


const ContactUs = () => {

    const handleEmailClick = () => {

        window.location.href =
            `mailto:${SUPPORT_EMAIL}`;

    };


    const handleWebsiteClick = () => {

        window.open(

            WEBSITE_URL,

            "_blank",

            "noopener,noreferrer"

        );

    };


    const handleBaleClick = () => {

        if (!BALE_CHANNEL_URL) return;

        window.open(

            BALE_CHANNEL_URL,

            "_blank",

            "noopener,noreferrer"

        );

    };


    const handleBazaarClick = () => {

        if (!BAZAAR_URL) return;

        window.open(

            BAZAAR_URL,

            "_blank",

            "noopener,noreferrer"

        );

    };

    const handleBaleSupportClick = () => {

        if (!BALE_SUPPORT_URL) return;

        window.open(
            BALE_SUPPORT_URL,
            "_blank",
            "noopener,noreferrer"
        );

    };

    const handlePwaClick = () => {

        // window.open(
        //     PWA_URL,
        //     "_blank",
        //     "noopener,noreferrer"
        // );

    };


    return (

        <main

            className={styles.page}

            dir="rtl"

        >

            {/* معرفی */}

            <section className={styles.hero}>

                <div className={styles.logo}>

                    <img
                        src={logo}
                        alt="AutoYad"
                    />

                </div>

                <div className={styles.heroContent}>

                    <span className={styles.eyebrow}>

                        درباره اتویــاد

                    </span>

                    <h1>

                        همراه شما برای مدیریت بهتر خودرو

                    </h1>

                    <p>

                        اتویاد کمک می‌کند اطلاعات خودرو،

                        سرویس‌ها و سوابق نگهداری آن را

                        ساده‌تر مدیریت و همیشه در دسترس

                        داشته باشید.

                    </p>

                </div>

            </section>


            {/* ارتباط با ما */}

            <section className={styles.section}>

                <div className={styles.sectionHeader}>

                    <div>

                        <span className={styles.sectionEyebrow}>

                            پشتیبانی

                        </span>

                        <h2>

                            با ما در ارتباط باشید

                        </h2>

                    </div>

                </div>


                <div className={styles.contactList}>

                    {/* کانال بله */}
                    <button

                        type="button"

                        className={`${styles.contactItem} ${
                            !BALE_CHANNEL_URL
                                ? styles.disabled
                                : ""
                        }`}

                        onClick={handleBaleClick}

                        disabled={!BALE_CHANNEL_URL}

                    >

                        <span className={styles.icon}>
                            <img
                                src={baleIcon}
                                alt="بله"
                            />
                        </span>

                        <span className={styles.contactText}>

                            <span className={styles.contactTitle}>

                                کانال اطلاع‌رسانی

                            </span>

                            <span className={styles.contactValue}>

                                پیام‌رسان بله

                            </span>

                        </span>

                        <span className={styles.arrow}>

                            ←

                        </span>

                    </button>

                    {/* پشتیبانی در بله */}
                    <button
                        type="button"
                        className={`${styles.contactItem} ${
                            !BALE_SUPPORT_URL
                                ? styles.disabled
                                : ""
                        }`}
                        onClick={handleBaleSupportClick}
                        disabled={!BALE_SUPPORT_URL}
                    >

                        <span className={styles.icon}>

                            <FaComments />

                        </span>

                        <span className={styles.contactText}>

                            <span className={styles.contactTitle}>

                                پشتیبانی در بله

                            </span>

                            <span className={styles.contactValue}>

                                گفتگو با تیم پشتیبانی

                            </span>

                        </span>

                        <span className={styles.arrow}>

                            ←

                        </span>

                    </button>

                    {/* صفحه بازار */}
                    <button

                        type="button"

                        className={`${styles.contactItem} ${
                            !BAZAAR_URL
                                ? styles.disabled
                                : ""
                        }`}

                        onClick={handleBazaarClick}

                        disabled={!BAZAAR_URL}

                    >

                        <span className={styles.icon}>

                            <img
                                src={bazaarIcon}
                                alt="بازار"
                                className={styles.serviceIcon}
                            />

                        </span>

                        <span className={styles.contactText}>

                            <span className={styles.contactTitle}>

                                صفحه برنامه در بازار

                            </span>

                            <span className={styles.contactValue}>

                                مشاهده و دریافت آخرین نسخه

                            </span>

                        </span>

                        <span className={styles.arrow}>

                            ←

                        </span>

                    </button>

                    {/* وب سایت */}
                    <button

                        type="button"

                        className={styles.contactItem}

                        onClick={handleWebsiteClick}

                    >

                        <span className={styles.icon}>

                            <FaGlobe />

                        </span>

                        <span className={styles.contactText}>

                            <span className={styles.contactTitle}>

                                وب‌سایت

                            </span>

                            <span className={styles.contactValue}>

                                {WEBSITE_URL.replace(

                                    "https://",

                                    ""

                                )}

                            </span>

                        </span>

                        <span className={styles.arrow}>

                            ←

                        </span>

                    </button>

                    {/* ایمیل */}
                    <button

                        type="button"

                        className={styles.contactItem}

                        onClick={handleEmailClick}

                    >

                        <span className={styles.icon}>

                            <FaEnvelope />

                        </span>

                        <span className={styles.contactText}>

                            <span className={styles.contactTitle}>

                                ایمیل پشتیبانی

                            </span>

                            <span className={styles.contactValue}>

                                {SUPPORT_EMAIL}

                            </span>

                        </span>

                        <span className={styles.arrow}>

                            ←

                        </span>

                    </button>

                    {/* PWA */}
                    <button
                        type="button"
                        className={styles.contactItem}
                        onClick={handlePwaClick}
                    >

                        <span className={styles.icon}>

                            <FaMobileAlt />

                        </span>

                        <span className={styles.contactText}>

                            <span className={styles.contactTitle}>

                                نسخه وب بدون نیاز به نصب

                            </span>

                            <span className={styles.contactValue}>

                                app.autoyad.ir

                            </span>

                        </span>

                        <span className={styles.arrow}>

                            ←

                        </span>

                    </button>

                </div>

            </section>


            {/* توضیح پایانی */}

            <section className={styles.note}>

                <div className={styles.noteIcon}>

                    💙

                </div>

                <div>

                    <h3>

                        نظر شما برای ما مهم است

                    </h3>

                    <p>

                        پیشنهادها و انتقادات شما به ما کمک

                        می‌کند اتویاد را بهتر و کاربردی‌تر

                        کنیم.

                    </p>

                </div>

            </section>


            {/* Footer */}

            <footer className={styles.footer}>

                <span>

                    اتویــاد

                </span>

                <span>

                    نسخه {APP_VERSION}

                </span>

                <span>

                    © تمامی حقوق محفوظ است

                </span>

            </footer>

        </main>

    );

};


export default ContactUs;